import { TOrganizationPeople } from '@/types/exam_signup';
import {
  requestFormDataPost,
  requestGet,
} from '@/services/request';
import {TSchList} from "@/types/exam";
import {TApi} from "@/types/api";

// 报名a系列考试
export const apiSignUpA = async (
  cert_id: string,
): Promise<TApi<{
  stateMsg: string;
  isSignupExam: boolean;
  examId: string;
  state: number;
  paperId: string;
}>> => {
  return requestGet('/v1/cert/signup/a', { certId: cert_id });
};
// 报名p系列考试
export const apiSignUpP = async (params: {
  certId: string;
  pTitle: string;
  schId?: string;
  url: string;
  oprice?: string;
  couponLogId?: string;
  couponId?: string;
  couponPurpose?: any;
  examStartTime?: number;
}): Promise<TApi<{
  stateMsg: string;
  isSignupExam: boolean;
  examId: string;
  state: number;
  paperId: string;
  accountOrderId: string | null;
}>> => {
  return requestFormDataPost('/v1/cert/signup/p', params);
};
// 报名FCRPD 替自己报名
export const apiSignUpFCRPDSingle = async (params: {
  certId: string;
  pTitle: string;
  schId?: string;
  url: string;
  oprice?: string;
  couponLogId?: string;
  couponId?: string;
  couponPurpose?: any;
  examStartTime?: number;
  msg: string;
}): Promise<TApi<{
  stateMsg: string;
  isSignupExam: boolean;
  examId: string;
  state: number;
  paperId: string;
  accountOrderId: string | null;
}>> => {
  return requestFormDataPost('/v1/cert/signup/exams', params);
};
// 报名FCRPD 替他人报名
export const apiSignUpFCRPD = async (params: {
  certId: string;
  pTitle: string;
  schId?: string;
  url: string;
  oprice?: string;
  couponLogId?: string;
  couponId?: string;
  couponPurpose?: any;
  examStartTime?: number;
  members: string;
}): Promise<TApi<{
  stateMsg: string;
  isSignupExam: boolean;
  examId: string;
  state: number;
  paperId: string;
  accountOrderId: string | null;
}>> => {
  return requestFormDataPost('/v1/cert/signup/batch', params);
};
// 获取p系列批次
export const apiGetSchBatch = async (
  cert_id: string,
): Promise<TApi<TSchList[]>> => {
  return requestGet('/v1/cert/sch/list', { certId: cert_id });
};
// 获取组织成员列表
export const apiGetOrganizationPeople = async (
  certId: string,
  current: number,
  search?: string,
): Promise<TApi<{ total: number; list: TOrganizationPeople[] }>> => {
  return requestGet('/v1/cert/company/members', { certId, current, search });
};
